import { useEffect } from "react";

function ReturnOrder() {
  useEffect(() => {
    // Load Termly script only once
    if (!document.getElementById("termly-jssdk")) {
      const script = document.createElement("script");
      script.id = "termly-jssdk";
      script.src = "https://app.termly.io/embed-policy.min.js";
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="return-wrapper">
      {/* Termly Embed */}
      <div
        name="termly-embed"
        data-id="d438e62e-9011-4d7d-b7ed-95ed7bfffd05"
      ></div>
    </div>
  );
}

export default ReturnOrder;
